import actionCreatorFactory from "./actionCreatorFactory";
import { Event } from "interfaces/content";

const actionCreator = actionCreatorFactory();
export const fetchEvents = actionCreator.async<void, Event[]>("FETCH_EVENTS");
